<style>
#investmentsRegister .v--modal-box.v--modal {
  min-height: 350px !important;
  min-width: 685px !important;
}
#investmentsRegister .modal__footer {
  display: none !important;
}
</style>

<template>
  <Modal
    modalName="investmentsRegister"
    title="Rejestr inwestycji"
    :buttons="[]"
    @closed="close"
  >
    <InvestmentsTable />
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";
import InvestmentsTable from "../../table/investments/InvestmentsTable.vue";

export default {
  components: {
    Modal,
    InvestmentsTable
  },
  data: () => ({
  }),
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    }
  },
  methods: {
    close() {
      if(!this.activeModals.includes('investmentCardModal')) {
        this.$root.$emit('removeMapLayer');
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/management/modals/InvestmentsRegister.vue